import { useState } from 'react';
import { useRecoilState } from 'recoil';
import { authState } from 'store/state';
import { useTranslation } from 'react-i18next';
import Connection from './Connection';
import Form from './Form';
import SubmitedAlert from './SubmitedAlert';
import StyledPrivateSale1 from './styles';

const PrivateSale = ({ data }) => {
    const [auth] = useRecoilState(authState);
    const { currentAddress } = auth || {};
    const [formSubmited, setFormSubmitted] = useState(false);
    const { t } = useTranslation();

    return (
        <StyledPrivateSale1 className="container">
            <h3>{data.subtitle}</h3>
            {currentAddress
                ? (formSubmited
                    ? <SubmitedAlert />
                    : (
                        <Form
                            t={t}
                            setFormSubmitted={setFormSubmitted}
                            rate={data.rate}
                        />
                    )
                )
                : (
                    <Connection
                        t={t}
                        connectionWarning={data.connectionWarning}
                        welcomeText={data.welcomeText}
                    />
                )}
        </StyledPrivateSale1>
    );
};

export default PrivateSale;
